import "./index.css";
import React, { useState } from "react";
import { Button, Tag, Tooltip, message } from "antd";
import orderApi from "@/services/api/order";
import { sortEwaybillNos } from "@/utils";
import OrderDTO from "@/dto/order/OrderDTO";
import EwaybillDTO from "@/dto/order/EwaybillDTO";
import EwaybillOperateModal from "./components/EwaybillOperateModal";
import { observer } from "mobx-react-lite";
import WaybillPrintDocumentNumber from "./components/WaybillPrintDocumentNumber";
import { useModalStore } from "@/hooks/Modal/hooks";
import LastLogisticsActivity from "./components/LastLogisticsActivity";
import { getEwaybillRealLogisticsCompanyNode } from "@/utils/EwaybillUtil";
import copy from "copy-to-clipboard";
import WaybillNoCategory from "@/enum/WaybillNoCategory";

interface WaybillNoProps {
    hasMultiEwaybillNos?: boolean;

    order: OrderDTO;

    isMainWaybillNo: boolean;

    hasEwaybillNo: boolean;

    ewaybill: EwaybillDTO;

    onUpdateMainEwaybillSuccess?(order: OrderDTO): void;
}

// 显示物流公司名、运单号及打印时间
const WaybillNo: React.FC<WaybillNoProps> = (props) => {
    const { ewaybill, hasMultiEwaybillNos, order, isMainWaybillNo, onUpdateMainEwaybillSuccess } = props;
    const modalStore = useModalStore();

    const { id, parentWaybillNo, waybillNo, dateCreated: printTime, orderItemsInfo, logisticsCompany } = ewaybill;

    const lastLogisticsActivity = ewaybill?.logisticsInfo?.lastLogisticsActivity;

    const lastLogisticsActivityTime = ewaybill?.logisticsInfo?.lastLogisticsActivityTime;

    const waybillNoClass = hasMultiEwaybillNos ? "waybill-no waybill-no-separator" : "waybill-no";

    const orderStatus = order.status;

    const [hoverWaybillNo, updateHoverWaybillNo] = useState(false);

    const showSetAsMainWaybillNoBtn =
        (orderStatus === "PENDING_PAYMENT" || orderStatus === "PENDING_SHIPMENT" || orderStatus === "SHIPPED") &&
        !isMainWaybillNo;

    const handleClick = (e) => {
        e.preventDefault();

        modalStore.openModal(EwaybillOperateModal, {
            order,
            ewaybill,
        });
    };

    const setAsMainWaybillNoBtnClick = (e) => {
        e.preventDefault();

        orderApi
            .updateMainWaybillNo({
                ewaybillId: id,
                logisticsCompany,
                waybillNo,
                orderId: order.id,
                shopId: order.shopId,
            })
            .then(() => {
                // 将主单号放到最前面
                const newOrder = sortEwaybillNos(order, waybillNo);

                onUpdateMainEwaybillSuccess?.({ ...newOrder, logisticsCompany });

                message.success("设置主运单号成功！");
            })
            .catch((e) => {
                message.error(`设置主运单号失败！${e}`);
            });
    };

    function handleCopyWaybillNo(e) {
        e.preventDefault();

        copy(waybillNo);

        message.success("复制成功");
    }

    const content =
        "子母单，是一票多包裹，多个包裹共用一个母运单号，子单号只是用来打印到面单上。仅母单号获取物流信息，订单发货可能只用母单号发货";

    return (
        <div className={waybillNoClass}>
            <p className="logistics-company-name">
                <span>{getEwaybillRealLogisticsCompanyNode(ewaybill)}</span>

                {ewaybill?.printBatchNo ? <span className="ml3 text-gray small">{ewaybill.printBatchNo}</span> : null}
            </p>

            <p
                onMouseEnter={() => {
                    updateHoverWaybillNo(true);
                }}
                onMouseLeave={() => {
                    updateHoverWaybillNo(false);
                }}
            >
                {ewaybill?.waybillNoCategory === WaybillNoCategory.CHILD ? (
                    <Tooltip title={content}>
                        <Tag variant="outlined" color="blue" style={{ marginRight: "2px", padding: "0 2px" }}>
                            子
                        </Tag>
                    </Tooltip>
                ) : null}

                {ewaybill?.waybillNoCategory === WaybillNoCategory.PARENT ? (
                    <Tooltip title={content}>
                        <Tag variant="outlined" color="blue" style={{ marginRight: "2px", padding: "0 2px" }}>
                            母
                        </Tag>
                    </Tooltip>
                ) : null}

                <a
                    className="waybill-no-text"
                    href="#"
                    onClick={handleClick}
                    title={parentWaybillNo ? `母单号：${parentWaybillNo}` : ""}
                >
                    {waybillNo}
                </a>

                {hoverWaybillNo ? (
                    <a className="small ml5" onClick={handleCopyWaybillNo}>
                        复制
                    </a>
                ) : null}
            </p>

            {showSetAsMainWaybillNoBtn ? (
                <p>
                    <a
                        href="#"
                        className="set-as-main-waybill-no-button"
                        onClick={setAsMainWaybillNoBtnClick}
                        title="将改运单号设置为该订单的主运单号"
                    >
                        设为主单号
                    </a>
                </p>
            ) : null}

            <p className="print-time text-light">
                {printTime}

                {ewaybill ? <WaybillPrintDocumentNumber ewaybill={ewaybill} /> : null}
            </p>

            <LastLogisticsActivity
                waybillNo={waybillNo}
                logisticsCompany={logisticsCompany}
                lastLogisticsActivity={lastLogisticsActivity}
                lastLogisticsActivityTime={lastLogisticsActivityTime}
            />
        </div>
    );
};

export default observer(WaybillNo);
